import React, { useState } from 'react';
import { Button as But, CircularProgress, Icon, Menu, MenuItem } from '@material-ui/core';
import Colors from '../../styles/colors';
import useStyles from './styles';
import { merge, get } from 'global/lib/lodash';

export const Button = (props) => {
  const classes = useStyles({ ...props, bgColor: props.bgColor || props.color || Colors.blue });
  const clss = merge({}, classes, props.classes);
  const [loading, setLoading] = useState(false);
  const { isLoading, ...rest } = props;

  const onClick = async (e) => {
    try {
      setLoading(true);
      props.onClick && (await props.onClick(e));
    } finally {
      setLoading(false);
    }
  };

  const ico = (() => {
    const icoobj = props.startIcon || props.icon;
    if (typeof icoobj === 'string') {
      return <Icon>{icoobj}</Icon>;
    }
    return icoobj;
  })();

  return (
    <But variant="contained" {...rest} startIcon={ico} onClick={onClick} classes={clss}>
      {props.title || props.children}
      {(props.loading || loading) && <CircularProgress size={12} />}
    </But>
  );
};

export const ButtonDrop = (props) => {
  const [state, setState] = useState({
    anchor: null,
  });

  const onClick = (e) => {
    setState((s) => ({ ...s, anchor: e.target }));
  };

  const onClose = () => {
    setState((s) => ({ ...s, anchor: null }));
  };

  const onSelect = (opt) => {
    props.onSelect && props.onSelect(opt);
    onClose();
  };

  const opts = get(props, 'options', []);

  return (
    <>
      <Button {...props} onClick={onClick} />
      <Menu id="simple-menu" anchorEl={state.anchor} keepMounted open={Boolean(state.anchor)} onClose={onClose}>
        {opts.map((opt, i) => (
          <MenuItem {...opt} onClick={() => onSelect(opt)}>
            {opt.title || opt.children}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
